import store from '@/store/store';
class ErrorHandler {
    constructor() {
    }
    logError(err, method) {
        console.log("------------" + method + "--------------");
        if (err.response) {
            store.dispatch('ToastMessage', { type: 'error', message: err.response.data });
            console.log('Error when invoking ' + method + ': ' + err.response);
            console.log("Error response:");
            console.log(err.response.data);
        }
        if (err.request) {
            console.log("Error request:");
            console.log(err.request);
        }
        else {
            console.log('Error when invoking ' + method + ': ' + err);
            console.log('Error', err.message);
        }
        if (err.config !== undefined) {
            console.log("Error Config:");
            console.log(err.config);
        }
        console.log("------------------------------------------------");
        store.dispatch('ToastMessage', { type: 'error', message: 'An error has occured in:' + method + ' check the logs for more information' });
    }
}
export default ErrorHandler;
